import { BRIGHTNESS_RULES } from '../../constants/rules';

export class BrightnessGenerator {
    constructor(templates) {
        this.templates = templates;
    }

    analyzeBrightnessDistribution(globalBrightness, partitionsData) {
        let conclusion = "";

        // 基本亮度描述
        if (!globalBrightness?.brightness?.level) {
            const rules = BRIGHTNESS_RULES.BASIC_BRIGHTNESS.condition(globalBrightness, partitionsData);
            if (rules.includes("noBrightnessData")) {
                conclusion = this.templates.brightness.analysis.noData;
            } else {
                conclusion = this.templates.brightness.analysis.noFeature;
            }
        } else {
            // 动态匹配基本亮度规则
            const rules = BRIGHTNESS_RULES.BASIC_BRIGHTNESS.condition(globalBrightness, partitionsData);

            if (rules.length > 0) {
                rules.forEach((rule) => {
                    const template = this.templates?.brightness?.rules?.basicBrightness?.[rule];

                    if (template) {
                        conclusion += conclusion
                            ? this.templates.brightness.analysis.conclusion.separator + template
                            : template;
                    }
                });
            } else {
                conclusion = this.templates.brightness.analysis.noBasicFeature;
            }
        }

        // 突出特征规则描述
        const featureRules = BRIGHTNESS_RULES.FEATURE_RULES.condition(globalBrightness, partitionsData);

        if (featureRules.length > 0) {
            featureRules.forEach(feature => {
                const description = this.templates?.brightness?.rules?.featureDescriptions?.[feature];
                if (description) {
                    conclusion = this.templates.brightness.analysis.conclusion.withFeatureRule
                        .replace("${basic}", conclusion)
                        .replace("${feature}", description);
                }
            });
        }

        // 细节层次描述
        const detailFeatures = BRIGHTNESS_RULES.DETAIL_FEATURES.condition(partitionsData);

        if (detailFeatures.length > 0) {
            detailFeatures.forEach(feature => {
                const description = this.templates?.brightness?.rules?.detailDescriptions?.[feature];
                if (description) {
                    conclusion = this.templates.brightness.analysis.conclusion.withDetailRule
                        .replace("${previous}", conclusion)
                        .replace("${detail}", description);
                }
            });
        }

        // 在最后添加period
        conclusion += this.templates.tones.analysis.conclusion.period;
        return conclusion;
    }

    generateConclusion(globalData, partitionsData) {
        return this.analyzeBrightnessDistribution(globalData, partitionsData);
    }
} 